/*
 * Robe tiers, sitewide.
 *
 * 1. The savings model (RobeTiers.keep / totalPct / unitPrice): the one JS copy
 *    of the tier + promo stacking maths. The Liquid copy is in
 *    snippets/pdp-v1-robe-offer.liquid; both follow the "Tier + promo savings
 *    math" theme setting (compound or add).
 *
 * 2. Tier progress. The qualifying-robe count needs product tags, which
 *    /cart.js doesn't return, so the progress markup is rendered in Liquid
 *    (sections/robe-tier-progress.liquid) and fetched with the Section
 *    Rendering API after every cart change: adds from any form or app, and
 *    quantity changes or removals in the Amp drawer. Cart changes are detected
 *    by watching fetch / XHR calls to /cart/add|change|update|clear.
 *    Fresh markup replaces every [data-robe-tiers-slot] (the PDP sticky bar)
 *    and the copy injected into the Amp drawer, and a robe-tiers:update event
 *    carries the new count (pdp-v1.js uses it for the sticky button label).
 *
 * 3. Amp drawer, when the theme setting "Tier progress in cart drawer" is on.
 *    The drawer is the Amp Slide Cart app, so the progress line is injected
 *    above its line items, the same way cart-gift-note.js injects the gift
 *    section, and re-placed if Amp rebuilds its DOM. Empty cart: removed.
 */
(function () {
  'use strict';
  if (window.RobeTiers) return;

  var cfgEl = document.getElementById('RobeTiersConfig');
  var cfg = {};
  try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { cfg = {}; }

  var RT = (window.RobeTiers = {
    cfg: cfg,
    count: null,
    html: null,
    version: 0,

    // Share of full price the shopper pays, for a tier % and a promo % (0 = none).
    keep: function (tierPct, promoPct) {
      var t = (tierPct || 0) / 100;
      var p = (promoPct || 0) / 100;
      return cfg.stacking === 'add' ? Math.max(0, 1 - t - p) : (1 - t) * (1 - p);
    },
    // Total saving against full price, in whole percent (never rounded up).
    totalPct: function (tierPct, promoPct) {
      return Math.floor((1 - RT.keep(tierPct, promoPct)) * 100 + 0.0001);
    },
    // Price per robe in cents.
    unitPrice: function (cents, tierPct, promoPct) {
      return Math.round(cents * RT.keep(tierPct, promoPct));
    },
    refresh: refresh
  });

  if (!cfg.tiersOn) return;

  /* ---------- Progress refresh ---------- */

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var refreshTimer = null;
  var inflight = 0;

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 150);
  }

  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var req = ++inflight;
    return nativeFetch(root + '?sections=' + encodeURIComponent(cfg.section), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) {
        if (!json || req !== inflight) return;
        var doc = new DOMParser().parseFromString(json[cfg.section] || '', 'text/html');
        var el = doc.querySelector('[data-robe-tiers-progress]');
        RT.html = el ? el.outerHTML : '';
        RT.count = el ? parseInt(el.getAttribute('data-count'), 10) || 0 : 0;
        RT.version++;
        apply();
      })
      .catch(function () {});
  }

  function apply() {
    if (RT.html === null) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-robe-tiers-slot]'), function (slot) {
      slot.innerHTML = RT.html;
    });
    placeInDrawer();
    document.dispatchEvent(new CustomEvent('robe-tiers:update', { detail: { count: RT.count } }));
  }

  // Count from the server-rendered progress (PDP sticky bar), so the first paint
  // needs no request.
  function readInitial() {
    var el = document.querySelector('[data-robe-tiers-slot] [data-robe-tiers-progress]');
    if (!el) return;
    RT.count = parseInt(el.getAttribute('data-count'), 10) || 0;
    RT.html = el.outerHTML;
    RT.version++;
  }

  /* ---------- Watch cart changes ---------- */

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(window, arguments);
    if (CART_MUTATION.test(url)) p.then(scheduleRefresh, function () {});
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__rtCart = CART_MUTATION.test(String(url || ''));
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__rtCart) this.addEventListener('loadend', scheduleRefresh);
    return xhrSend.apply(this, arguments);
  };

  /* ---------- Amp drawer ---------- */

  function placeInDrawer() {
    if (!cfg.drawer) return;
    var drawer = document.querySelector('#slidecarthq .slidecarthq');
    if (!drawer) return;
    var items = drawer.querySelector('.items');
    var existing = drawer.querySelector('[data-robe-tiers-drawer]');
    // No line items: an empty cart, nothing to make progress on.
    if (!items || !items.querySelector('.item') || !RT.html) {
      if (existing) existing.parentNode.removeChild(existing);
      return;
    }
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'robe-tiers-drawer';
      existing.setAttribute('data-robe-tiers-drawer', '');
    }
    // Compare versions, not markup: re-serialised HTML can differ from the
    // string, which would rewrite the node on every mutation.
    if (existing.__rtVersion !== RT.version) {
      existing.innerHTML = RT.html;
      existing.__rtVersion = RT.version;
    }
    if (existing.nextElementSibling !== items) items.parentNode.insertBefore(existing, items);
  }

  var placeTimer = null;
  function schedulePlace() {
    if (placeTimer) return;
    placeTimer = setTimeout(function () {
      placeTimer = null;
      // First drawer open on a page with no server-rendered progress: fetch it.
      if (RT.html === null) {
        if (document.querySelector('#slidecarthq .slidecarthq .items')) refresh();
        return;
      }
      placeInDrawer();
    }, 60);
  }

  function start() {
    readInitial();
    // pdp-v1.js (deferred) is already running by now; give it the count.
    if (RT.count !== null) {
      document.dispatchEvent(new CustomEvent('robe-tiers:update', { detail: { count: RT.count } }));
    }
    // Drawer progress is a theme setting (off while tiers cover only some robes).
    if (!cfg.drawer) return;
    // Observe body, not #slidecarthq: Amp can replace its own root.
    try {
      new MutationObserver(schedulePlace).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    schedulePlace();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
